import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../api/queryClient.js";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  membershipIds: yup.array().of(yup.number()).required(),
});

export function useSetMembershipsObOrderMutation(options = {}) {
  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.setMembershipsObOrder(), {
        ids: req.membershipIds,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.membershipsObOrder],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
